export const baoCao = {
  invalid: 'Báo cáo không hợp lệ',
  moiQuanTam: 'Mối quan tâm',
  loaiBaoCao: 'Loại báo cáo',
  thoiGian: 'Thời gian',
  empty: 'Báo cáo không có dữ liệu',
  chartTitle: 'Biểu đồ',
  chartEmpty: 'Không có số liệu để vẽ biểu đồ',
  hideChart: 'Ẩn biểu đồ',
  showChart: 'Hiện biểu đồ',
  giaiThich: {
    nut: 'Cách tính',
    tieuDe: 'Cách tính số liệu',
    tenKhac: 'Dạng danh sách: {ten}',
    dong: 'Đóng',
  },
  range: 'Từ ngày {tu} đến ngày {den}',
  dateRangePlaceholder: 'Chọn khoảng ngày',
  fromDate: 'Từ ngày',
  toDate: 'Đến ngày',
  maGiaoDich: 'Mã giao dịch',
  maHangHoa: 'Mã hàng hóa',
  tenHangHoa: 'Tên hàng hóa',
  filter: {
    searchPlaceholder: 'Tìm mã chứng từ, mã/tên hàng, khách hàng',
    textDetailTitle: 'Bộ lọc chi tiết',
  },
  aria: {
    columnPicker: 'Điều chỉnh cột',
  },
  reports: {
    tongHop: 'Báo cáo tổng hợp',
    doanhThuLn: 'Doanh thu, lợi nhuận',
    tonKho: 'Báo cáo tồn kho',
    topSale: 'Top sale',
    topMua: 'Top mua',
  },
  bangChiTiet: 'Bảng chi tiết',
  hienThi: { title: 'Dạng hiển thị', PIVOT: 'Pivot', DS: 'Danh sách' },
  tongCong: 'Tổng cộng',
  loiTai: 'Không tải được báo cáo: {msg}',
  concernGroups: {
    tongHop: 'Tổng hợp',
    soSanhKy: 'So sánh kỳ',
    thangChiNhanh: 'Tháng × chi nhánh',
    margin: 'Margin & lợi nhuận',
  },
  concernsShort: {
    khach: 'Theo khách hàng',
    sanPham: 'Theo sản phẩm',
    nhom: 'Theo nhóm hàng',
    khachSp: 'Theo khách + sản phẩm',
    mgKhach: 'NVBH + khách hàng',
    mgNhom: 'Nhóm KPI + NVBH',
    lnThang: '% LN theo tháng',
  },
  soDong: '{n} dòng',
  truncated: 'Chỉ hiển thị 2.000 dòng đầu. Thu hẹp khoảng ngày hoặc bộ lọc để xem đủ.',
  concerns: {
    banHang: 'Bán hàng',
    thuChi: 'Thu chi',
    hangHoa: 'Hàng hóa',
    tongHop: 'Tổng hợp',
    thoiGian: 'Thời gian',
    loiNhuan: 'Lợi nhuận',
    giamGiaHd: 'Giảm giá HĐ',
    traHang: 'Trả hàng',
    nhanVien: 'Nhân viên',
    chiNhanh: 'Chi nhánh',
    giaoDich: 'Giao dịch',
    giaTriKho: 'Giá trị kho',
    xuatNhapTon: 'Xuất nhập tồn',
    xuatHuy: 'Xuất hủy',
    congNo: 'Công nợ',
    nhapHang: 'Nhập hàng',
    chiTietHd: 'Chi tiết hóa đơn',
    soSanhKy: 'So sánh kỳ',
    chiTietNgan: 'Chi tiết',
    soSanhNgan: 'So sánh',
    thangNhom: 'Tháng + nhóm SP',
    nvkdNhom: 'NVKD + tháng + nhóm',
    nvkdKhach: 'NVKD + tháng + khách',
    khachThang: 'Khách hàng + tháng',
    tonNgay: 'Tồn kho hàng ngày',
    tonKy: 'Tồn kho theo kỳ',
    tonGiaoDich: 'Chi tiết nhập xuất',
    tonGoiY: 'Nonmoving + gợi ý đặt',
    tonGoiYGop: 'Gợi ý đặt (gộp chi nhánh)',
    topSanPham: 'Theo sản phẩm',
    topToanBo: 'Gộp toàn phạm vi',
    topTungMang: 'Trong từng mảng',
    topTungChiNhanh: 'Trong từng chi nhánh',
    topChiNhanh: 'Theo sản phẩm + chi nhánh',
    ssKhach: 'So sánh kỳ theo khách hàng',
    ssSanPham: 'So sánh kỳ theo sản phẩm',
    ssNhom: 'So sánh kỳ theo nhóm hàng',
    pvSanPham: 'Tháng × chi nhánh theo sản phẩm',
    pvKhach: 'Tháng × chi nhánh theo khách hàng',
    pvKhachSp: 'Tháng × chi nhánh theo khách + sản phẩm',
    mgKhach: 'Margin theo NVBH + khách hàng',
    mgNhom: 'Margin theo nhóm KPI + NVBH',
    lnThang: '% LN tháng theo nhóm KPI + chi nhánh',
  },
  kpi: {
    dt: 'Doanh thu thuần',
    ln: 'Lợi nhuận',
    margin: '% Margin',
    sl: 'Số lượng',
    so: 'so',
    thamChieu: 'tham chiếu',
    diemPct: 'điểm %',
  },
  charts: {
    trend: 'Xu hướng theo tháng',
    top: 'Top {n} theo {metric}',
    coCau: 'Cơ cấu {metric} theo {dim}',
    theoKy: 'Doanh thu & lợi nhuận theo kỳ',
    topKy: 'Top {n} doanh thu {nhan} so với các kỳ',
    khac: 'Khác',
  },
  soSanh: {
    kySection: 'Kỳ so sánh',
    kieuKy: 'Kiểu kỳ',
    luyKeNgan: 'Lũy kế',
    kieuKyOptions: {
      THANG: 'Tháng',
      QUY: 'Quý',
      NAM: 'Năm',
      N_THANG: 'Nhiều tháng',
      LUY_KE: 'Lũy kế năm',
      TUAN: 'Tuần',
      TUY_CHON: 'Tùy chọn',
    },
    denThang: 'Đến tháng',
    nam: 'Năm',
    quy: 'Quý',
    thang: 'Tháng',
    tuThang: 'Từ tháng',
    tuNgan: 'Từ',
    denNgan: 'Đến',
    soThang: 'Số tháng',
    soThangValue: '{n} tháng',
    tuan: 'Tuần',
    tuyChon: {
      loai: { THANG: 'Tháng', QUY: 'Quý', NAM: 'Năm', TUAN: 'Tuần', NGAY: 'Khoảng ngày' },
      loaiNgan: { THANG: 'Tháng', QUY: 'Quý', NAM: 'Năm', TUAN: 'Tuần', NGAY: 'Ngày' },
      kyGoc: 'Kỳ gốc',
      kyN: 'Kỳ {n}',
      themKy: 'Thêm kỳ so sánh',
      xoaKy: 'Xóa kỳ',
      tuanShort: 'Tuần {n}',
    },
    chiNhanhSection: 'Chi nhánh',
    tachChiNhanh: 'Tách từng chi nhánh',
  },
  phamVi: {
    duAnSection: 'Mảng (dự án)',
    duAnMacDinh: 'Mảng đang đứng',
    duAnEmpty: 'Không có dự án',
    chonTatCa: 'Chọn tất cả',
    boChonTatCa: 'Bỏ chọn tất cả',
    chonNhanh: 'Chọn nhanh phạm vi',
    toanHeThong: 'Toàn hệ thống',
    mangDangDung: 'Mảng đang đứng',
    chiNhanhDangDung: 'Chi nhánh đang đứng',
    section: 'Phạm vi',
    heThongNgan: 'Hệ thống',
    mangNgan: 'Mảng',
    chiNhanhNgan: 'Chi nhánh',
  },
  topSale: {
    section: 'Tùy chọn top',
    xepHang: 'Xếp hạng',
    xepHangNgan: { TOAN_BO: 'Toàn phạm vi', TUNG_MANG: 'Theo mảng', TUNG_CHI_NHANH: 'Theo chi nhánh' },
    tieuChi: 'Xếp theo',
    tieuChiOptions: { DOANH_THU: 'Doanh thu', SO_LUONG: 'Số lượng', LOI_NHUAN: 'Lợi nhuận' },
    soTop: 'Lấy top',
    soTopValue: 'Top {n}',
    kieuXep: 'Cách tính',
    kieuXepOptions: { KY: 'Cộng cả kỳ', THANG: 'Từng tháng' },
    kieuXepHint: {
      KY: 'Cộng dồn cả khoảng ngày rồi xếp hạng.',
      THANG: 'Xếp hạng riêng từng tháng, đếm số tháng sản phẩm lọt top.',
    },
    tomTat: {
      top: 'Top {n} theo {tieuChi}',
      phan: {
        TOAN_BO: 'Gộp toàn phạm vi',
        TUNG_MANG: 'Xếp hạng trong từng mảng',
        TUNG_CHI_NHANH: 'Xếp hạng trong từng chi nhánh',
      },
      soMang: '{n} mảng',
      soChiNhanh: '{n} chi nhánh',
      tatCaChiNhanh: 'tất cả chi nhánh',
    },
    kpi: {
      soSp: 'Sản phẩm top',
      soKh: 'Khách top',
      soHd: 'Số hóa đơn',
      sl: 'SL bán thuần',
      dtTruocTra: 'Doanh thu',
      traHang: 'Trả hàng',
    },
  },
  tonKho: {
    kpi: {
      soMa: 'Mã hàng',
      soPhieu: 'Số phiếu',
      tonDau: 'Tồn đầu kỳ',
      nhap: 'Nhập trong kỳ',
      xuat: 'Xuất trong kỳ',
      tonCuoi: 'Tồn cuối kỳ',
      bienDong: 'Biến động tồn',
      chenhLech: 'Nhập − xuất',
      doanhSo: 'Doanh số trong kỳ',
      gp: 'Lợi nhuận gộp',
      nonmoving: 'Mã nonmoving',
      tonCao: 'Mã tồn kho cao',
      canDat: 'Mã cần đặt (30 ngày)',
      choGiao: 'Chờ giao',
    },
    sub: {
      sl: 'SL {v}',
      slBan: 'SL bán {v}',
      slDat: 'Gợi ý đặt {v}',
      fm: 'FM {v}',
      giaTri: 'Giá trị {v}',
    },
  },
  luu: {
    nutLuu: 'Lưu',
    nutDaLuu: 'Đã lưu',
    tieuDe: 'Lưu báo cáo',
    suaTieuDe: 'Sửa báo cáo đã lưu',
    trangTieuDe: 'Báo cáo đã lưu',
    luu: 'Lưu',
    huy: 'Hủy',
    sua: 'Sửa',
    xoa: 'Xóa',
    boGhim: 'Bỏ ghim',
    dangLuu: 'Đang lưu…',
    dangChup: 'Đang chụp dữ liệu…',
    daLuu: 'Đã lưu «{ten}»',
    daXoa: 'Đã xóa báo cáo đã lưu',
    xemDanhSach: 'Xem danh sách',
    xemTatCa: 'Xem tất cả báo cáo đã lưu',
    chuaCo: 'Chưa có báo cáo nào được lưu',
    moTaPhamVi: 'Kỳ: {ky}',
    soBang: '{n} bảng dữ liệu',
    ghimMoTa: 'Bản chụp được ghim sẽ không tự hết hạn sau 180 ngày.',
    taiExcel: 'Tải Excel',
    chayLai: 'Chạy lại với dữ liệu mới',
    tatCaThoiGian: 'Tất cả thời gian',
    chiBanChup: 'Chỉ dùng được với báo cáo lưu kiểu bản chụp',
    khongCoQuyenSua: 'Bạn không có quyền sửa báo cáo này',
    moBanChup: 'Mở bản chụp',
    moBoLoc: 'Mở với bộ lọc đã lưu',
    daHetHan: 'Hết hạn',
    khongHetHan: 'Không hết hạn',
    biCat: 'Dữ liệu đã bị cắt bớt khi lưu',
    xuLyTrong: 'Xử lý {s} giây',
    chiCuaToi: 'Chỉ báo cáo của tôi',
    cuaToi: 'Của tôi',
    tatCaLoai: 'Tất cả báo cáo',
    tatCaKieu: 'Tất cả',
    timKiem: 'Tìm kiếm',
    timKiemPlaceholder: 'Tìm theo tên, ghi chú báo cáo',
    xacNhanXoa: 'Xóa báo cáo đã lưu «{ten}»? Dữ liệu bản chụp cũng bị xóa.',
    boLocBiKhoa: 'Đang xem bản chụp — bấm «Chạy lại với dữ liệu mới» để đổi bộ lọc',
    khongCoTrongBanChup: 'Bản chụp không có dữ liệu cho cấu hình này. Bấm «Chạy lại với dữ liệu mới» để truy vấn lại.',
    kieu: {
      BAN_CHUP: 'Bản chụp dữ liệu',
      BO_LOC: 'Chỉ bộ lọc',
    },
    kieuMoTa: {
      BAN_CHUP: 'Lưu cả số liệu tại thời điểm này để xem lại, tải Excel đúng như lúc lưu.',
      BO_LOC: 'Chỉ lưu điều kiện lọc, mở lại sẽ chạy với dữ liệu mới nhất.',
    },
    chiaSe: {
      CA_NHAN: 'Chỉ mình tôi',
      DU_AN: 'Mọi người trong dự án',
    },
    truong: {
      ten: 'Tên',
      ghiChu: 'Ghi chú',
      kieu: 'Kiểu lưu',
      chiaSe: 'Chia sẻ',
      ghim: 'Ghim',
      loaiBaoCao: 'Báo cáo',
      khoangNgay: 'Khoảng ngày',
      thoiGianTruyVan: 'Thời điểm truy vấn',
      soDong: 'Số dòng',
      nguoiLuu: 'Người lưu',
      hetHan: 'Hết hạn',
      boLoc: 'Bộ lọc',
      tenBaoCao: 'Tên báo cáo',
      tuNgay: 'Từ ngày',
      denNgay: 'Đến ngày',
      thoiGianXuLy: 'Thời gian xử lý',
      kichThuoc: 'Dung lượng',
      ngayTao: 'Ngày lưu',
      trangThai: 'Trạng thái',
      thaoTac: 'Thao tác',
    },
    soGiay: '{s} giây',
    conHan: 'Còn hạn',
    anHienCot: 'Ẩn/hiện cột',
    ngan: {
      reports: {
        doanhThuLn: 'DT-LN',
        tonKho: 'Tồn kho',
        topSale: 'Top sale',
        topMua: 'Top mua',
      },
      concerns: {
        chiTietHd: 'Chi tiết',
        soSanhKy: 'So sánh',
        giamGiaHd: 'Giảm giá',
        xuatNhapTon: 'XNT',
        tonNgay: 'Hàng ngày',
        tonKy: 'Theo kỳ',
        tonGiaoDich: 'Nhập xuất',
        tonGoiY: 'Gợi ý đặt',
        topTungMang: 'Theo mảng',
        topTungChiNhanh: 'Theo CN',
      },
    },
    banner: {
      dangTai: 'Đang tải bản chụp…',
      loi: 'Không mở được bản chụp: {msg}',
      dangXem: 'Đang xem bản chụp «{ten}»',
      truyVanLuc: 'Số liệu lúc {tg}',
      nguoiLuu: 'Người lưu: {ten}',
    },
    excel: {
      sheetThongTin: 'Thông tin',
      pivot: 'pivot',
    },
  },
  pivot: {
    title: 'Bảng pivot',
    titleDs: 'Danh sách',
    mauLabel: 'Mẫu:',
    tuyChinh: 'Tùy chỉnh',
    moCap: 'Mở đến cấp',
    thuGon: 'Thu gọn',
    truncated: 'Dữ liệu quá lớn, chỉ gom {n} dòng đầu. Thu hẹp thời gian, phạm vi hoặc bớt trường.',
    nhieuDong: 'Đang hiện {n} dòng đầu — thu gọn bớt để xem phần còn lại.',
    nhieuDongDs: 'Đang hiện {n} dòng đầu — thu hẹp bộ lọc để xem phần còn lại.',
    soNhom: '{n} nhóm cấp 1',
    chonGiaTri: 'Chọn ít nhất một chỉ số ở ô Chỉ số.',
    sapTheoNhan: 'Bấm để sắp xếp theo tên',
    sapTheoCot: 'Bấm để sắp xếp theo cột này (giảm dần → tăng dần → bỏ)',
    thang: 'Tháng {n}',
    quy: 'Quý {n}',
    tongCua: 'Tổng {label}',
    timTruong: 'Tìm trường / chỉ số',
    tongPhuCot: 'Hiện cột tổng phụ cho từng nhóm cột',
    giaTriTruoc: 'Nhóm cột theo chỉ số',
    giaTriTruocMoTa: 'Tiêu đề cột: chỉ số ở trên, kỳ bên dưới (chỉ số › kỳ)',
    nhomTheo: 'Nhóm theo',
    dongTheoCap: 'Dòng theo cấp',
    giaTriSection: 'Giá trị',
    chiaCot: 'Chia cột theo',
    chiSoNut: 'Chỉ số',
    soChiSo: '{n} chỉ số',
    khongChon: 'Không',
    sapXep: 'Sắp xếp',
    sapMacDinh: 'Mặc định',
    sapNhanTang: 'Theo tên A → Z',
    sapNhanGiam: 'Theo tên Z → A',
    giamDan: 'giảm dần',
    tangDan: 'tăng dần',
    motCot: 'một cột',
    themLoc: 'Thêm lọc',
    locTatCa: 'Tất cả',
    locRong: 'Không chọn',
    locSo: '{n}/{m}',
    lenTren: 'Lên trên',
    xuongDuoi: 'Xuống dưới',
    stt: 'STT',
    boMuc: 'Bỏ',
    themCap: 'Thêm cấp dòng…',
    themChiSo: 'Thêm chỉ số…',
    themTatCa: 'Thêm tất cả',
    boHet: 'Bỏ hết',
    khongTimThay: 'Không tìm thấy',
    chuaChonCap: 'Chưa chọn cấp — bảng chỉ hiện dòng tổng.',
    chuaChonChiSo: 'Chưa chọn chỉ số nào.',
    locGiaTri: {
      title: 'Lọc giá trị',
      tim: 'Tìm giá trị',
      chonTatCa: 'Chọn tất cả',
      boChon: 'Bỏ chọn tất cả',
      conNua: 'Còn {n} giá trị — gõ để tìm',
      dangChon: 'Đang chọn {n}/{m}',
      xoaLoc: 'Xóa lọc',
      xong: 'Xong',
    },
    mau: {
      hoaDon: 'Ngày + NVKD (tháng hiện tại)',
      tongHop: 'Tổng hợp theo năm',
      thangNhom: 'Tháng + nhóm hàng',
      nvkdNhom: 'NVKD + tháng + nhóm',
      nvkdKhach: 'NVKD + tháng + khách',
      khachThang: 'Khách × tháng (hàng ngang)',
      thangChiNhanh: 'Tháng × chi nhánh',
      marginKhach: 'Margin NVKD + khách',
      ssNhomHang: 'Nhóm hàng › mã hàng',
      ssNvkdNhom: 'NVKD › nhóm hàng › mã hàng',
      ssNvkdKhach: 'NVKD › khách hàng',
      ssKhachHang: 'Khách hàng › mã hàng',
      tonNgay: 'Tồn từng ngày',
      tonKy: 'Tồn theo chi nhánh',
      tonThang: 'Tồn cuối từng tháng',
      tonGiaTri: 'Giá trị tồn',
      gdDoc: 'Nhập xuất theo ngày',
      gdLoaiPhieu: 'Theo loại phiếu (hàng ngang)',
      gdHuong: 'Nhập / xuất × loại phiếu',
      goiYNhom: 'Tất cả hàng',
      chiNonmoving: 'Chỉ nonmoving',
      goiYChiNhanh: 'Theo chi nhánh',
    },
    truong: {
      nam: 'Năm',
      quy: 'Quý',
      thang: 'Tháng',
      ngay: 'Ngày',
      thangNam: 'Tháng/Năm',
      ngayDayDu: 'Ngày/Tháng/Năm',
      mang: 'Mảng (dự án)',
      chiNhanh: 'Chi nhánh',
      nvkd: 'NVKD',
      nhom1: 'Nhóm hàng cấp 1',
      nhom2: 'Nhóm hàng cấp 2',
      nhom3: 'Nhóm hàng cấp 3',
      nhom: 'Nhóm hàng (đủ 3 cấp)',
      hang: 'Mã - Tên hàng',
      khach: 'Mã - Tên khách',
      cuMoi: 'Khách cũ / mới',
      maHd: 'Mã hóa đơn',
      tinh: 'Tỉnh / thành',
      phuong: 'Phường / xã',
      kySs: 'Kỳ',
      huong: 'Nhập / Xuất',
      loai: 'Loại phiếu',
      maPhieu: 'Mã phiếu',
      nonmoving: 'Nonmoving',
      tinhTrang: 'Tình trạng',
      noteTop: 'Note top sale',
      dangKd: 'Đang kinh doanh',
    },
    chiSo: {
      sl: 'SL',
      slTbThang: 'SL TB/tháng',
      doanhThu: 'Doanh thu',
      giamGia: 'Giảm giá',
      thuKhac: 'Thu khác',
      vat: 'VAT',
      traHang: 'Trả hàng',
      dtThuan: 'DT thuần',
      giaVon: 'Giá vốn',
      loiNhuan: 'Lợi nhuận',
      lnTrenVon: '% LN/giá vốn (markup)',
      margin: '% LN/doanh thu (margin)',
      tyTrong: '% Thị phần DT',
      xepHang: 'Xếp hạng DT',
      soKg: 'Số kg',
      soKhoi: 'Số khối',
      tonDau: 'SL tồn đầu',
      gtDau: 'GT tồn đầu',
      kgDau: 'Kg tồn đầu',
      khoiDau: 'Khối tồn đầu',
      slNhap: 'SL nhập',
      gtNhap: 'GT nhập',
      slXuat: 'SL xuất',
      gtXuat: 'GT xuất',
      tonCuoi: 'SL tồn cuối',
      gtCuoi: 'GT tồn cuối',
      kgCuoi: 'Kg tồn cuối',
      khoiCuoi: 'Khối tồn cuối',
      slPs: 'SL phát sinh',
      gtPs: 'GT phát sinh',
      tonBq: 'Tồn bình quân',
      vongQuay: 'Vòng quay',
      roii: 'ROII',
      slBan: 'SL bán',
      doanhSo: 'Doanh số',
      gp: 'Lợi nhuận gộp',
      fm: '% FM',
      slYoy: 'SL cùng kỳ',
      dtYoy: 'DT cùng kỳ',
      slCho: 'SL chờ giao',
      gtCho: 'GT chờ giao',
      goiY30: 'Gợi ý đặt 30 ngày',
      goiY60: 'Gợi ý đặt 60 ngày',
    },
    giaTriTruong: {
      moi: 'Mới',
      cu: 'Cũ',
      nhap: 'Nhập',
      xuat: 'Xuất',
      nonmoving: 'Nonmoving',
      binhThuong: 'Bình thường',
      tonCao: 'Tồn kho cao',
      nonmovingTonCao: 'Nonmoving, tồn kho cao',
      topSale: 'Top sale',
      khac: 'Khác',
      dangKd: 'Đang KD',
      ngungKd: 'Ngừng KD',
      NHAP_MUA: 'Nhập mua',
      NHAP_CHUYEN: 'Nhập chuyển',
      NHAP_TRA_HANG: 'Nhập trả hàng',
      NHAP_DIEU_CHINH: 'Nhập điều chỉnh',
      NHAP_KHAC: 'Nhập khác',
      XUAT_BAN: 'Xuất bán',
      XUAT_CHUYEN: 'Xuất chuyển',
      XUAT_TRA_NCC: 'Xuất trả NCC',
      XUAT_HUY: 'Xuất hủy',
      XUAT_NOI_BO: 'Xuất nội bộ',
      XUAT_DIEU_CHINH: 'Xuất điều chỉnh',
      XUAT_KHAC: 'Xuất khác',
      KIEM_KE: 'Kiểm kê',
      kiemKe: 'Kiểm kê',
    },
  },
}
